<template>
<div class="takeaway-wrapper">
  <div v-if="clientPlatform == 'Web'" class="takeaway-desktop">
    <take-away-page-body />
  </div>
  <div v-if="clientPlatform !== 'Web'" class="takeaway-pwa">
    <generic-modal
      :width="orderSelectionModal.width"
      :modalClass="orderSelectionModal.modalClass"
      :height="orderSelectionModal.height"
    >
      <template v-slot:header>
        <take-away-page-header />
      </template>
      <template v-slot:body>
        <take-away-page-body />
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import TakeAwayPageHeader from "./TakeAwayPageHeader.vue";
import TakeAwayPageBody from "./TakeAwayPageBody.vue";
import { clientPlatform } from "../config/apiEndpoints";

export default {
  name: "TakeAwayPage",
  components: {
    GenericModal,
    TakeAwayPageHeader,
    TakeAwayPageBody,
  },
  data() {
    return {
      clientPlatform,
      orderSelectionModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup cust-modal-wrap take-away-container",
        currentSlide: 0,
      },
    };
  },
  mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>

<style></style>
